import repository from "../Repository";

export default {
  async getFacility(municipCode, areaCode, facilityClass, screenId) {
    const res = await repository.post(
      `facility`,
      {
        municip_code: municipCode,
        area_code: areaCode,
        facility_class: facilityClass
      },
      {
        headers: { s: screenId }
      }
    );
    return res;
  },
  async list(screenId, municipality, facilityClass) {
    return repository.post(
      `facility`,
      {
        municip_code: municipality,
        facility_class: facilityClass
      },
      {
        headers: {
          s: screenId
        }
      }
    );
  }
};
